import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

interface Product {
  id: number;
  name: string;
  title?: string;
  price: string;
  image: string | null;
  description: string;
  short_description?: string;
  stock: number;
  category_id: number;
  category_name: string;
  status: string;
  is_featured: number;
  created_at: string;
}


const ProductDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [product, setProduct] = useState<Product | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    
    fetch(`https://fellfell.ir/api/products.php?action=single&id=${id}`, {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(data => {
        console.log('📦 پاسخ محصول:', data);
        if (data.success && data.data) {
          setProduct(data.data);
        } else {
          setError(data.message || 'محصول یافت نشد');
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('❌ خطا:', err);
        setError('خطا در بارگذاری محصول');
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        ⏳ در حال بارگذاری محصول...
      </div>
    );
  }

  if (error || !product) {
    return (
      <div style={{ padding: '20px', color: '#c62828', background: '#ffebee', borderRadius: '10px' }}>
        ❌ {error || 'محصول یافت نشد'}
      </div>
    );
  }

  const productName = product.title || product.name || 'بدون نام';

  return (
    <>
      <div style={{ background: '#1e3a1e', color: '#fff', padding: '40px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <h1 style={{ fontSize: '28px' }}>{productName}</h1>
        </div>
      </div>
      
      <section style={{ padding: '30px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px' }}>
            <div>
			
              <img 
                src={product.image ? `https://fellfell.ir/uploads/products/${product.image}` : '/images/default-product.jpg'} 
                alt={productName} 
                style={{ width: '100%', borderRadius: '12px',     aspectRatio: '1/1',        // ← کلید اصلی
maxHeight: '400px', objectFit: 'cover' }}
                onError={(e) => { (e.target as HTMLImageElement).src = '/images/default-product.jpg'; }}
				 loading="lazy"               // ← اضافه شد برای بهینه‌سازی
  decoding="async"             // ← اضافه شد برای بهینه‌سازی
              />
            </div>
            <div>
              <h2 style={{ fontSize: '24px', color: '#1e3a1e', marginBottom: '10px' }}>{productName}</h2>
              <p style={{ color: '#666', marginBottom: '10px' }}>
                دسته: {product.category_name || 'نامشخص'}
              </p>
              <p style={{ color: '#2E7D32', fontSize: '24px', fontWeight: 'bold', marginBottom: '10px' }}>
                {new Intl.NumberFormat('fa-IR').format(Number(product.price))} تومان
              </p>
              <p style={{ marginBottom: '10px' }}>
                موجودی: {product.stock > 0 ? product.stock : 'ناموجود'}
              </p>
              <p style={{ marginBottom: '20px', lineHeight: '1.8' }}>
                {product.description || 'توضیحی برای این محصول وجود ندارد.'}
              </p>
              <button style={{ padding: '12px 30px', background: '#2e7d32', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '16px', fontWeight: '600' }}>
                🛒 افزودن به سبد خرید
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductDetail;